import React from 'react';

export const PermissionsContext = React.createContext({ permissions: {} });
